import { TrackJS } from 'trackjs';

let nbErreurs = 0;

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.config.errorHandler = function (err, vm, info) {

    if (TrackJS.isInstalled()) {
      if (nbErreurs > 20) {
        return;
      }
      if (vm && vm.$options && vm.$options.name) {
        TrackJS.console.debug(vm.$options.name);
      }
      TrackJS.console.debug(info);
      TrackJS.track(err);
      nbErreurs++;
    } else {
      console.error(err, info);
    }
  };
  window.onerror = (msg, src, ligne, col, erreur) => {
    const toSend = {
      message: msg,
      line: ligne,
      column: col,
      source: src,
      error: erreur
    };
    if (TrackJS.isInstalled()) {
      if (nbErreurs > 20) {
        return;
      }

      TrackJS.console.debug(toSend);
      TrackJS.track(erreur);
      nbErreurs++;
    } else {
      console.error(toSend);
    }
  }
});
